import React from 'react';
import {
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

import { TP_COLORS } from '../../../constants';
import { getSubjectColorNew, getSubjectIconName } from '../../../helper';

interface ViewEventModalProps {
  open: boolean;
  onClose: () => void;
}

const data = {
  subject: 'Mathematics',
};

const ViewEventModal: React.FC<ViewEventModalProps> = ({ open, onClose }) => {
  const subjectColor = getSubjectColorNew(data.subject);
  const subjectIconName = getSubjectIconName(data.subject);
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: '20px' } }}
    >
      <DialogTitle>Class Details</DialogTitle>
      <DialogContent>
        <Stack gap={2}>
          <Card
            sx={{
              borderRadius: '10px',
              background: `url('${process.env.PUBLIC_URL}/images/subjectPage/shape-header.png') top right/contain no-repeat, url('${process.env.PUBLIC_URL}/images/landingPage/icon-${subjectIconName}-white.png') right center/contain no-repeat, ${subjectColor}`,
              color: TP_COLORS.white,
            }}
          >
            <CardContent style={{ padding: '16px' }}>
              <Typography fontWeight={500} fontSize="18px">
                {data.subject}
              </Typography>
            </CardContent>
          </Card>
        </Stack>
      </DialogContent>
      {/* <DialogActions sx={{ p: '16px' }}>
        <Button
          size="small"
          variant="contained"
          color="primary"
        >
          {mode === 'edit' ? 'Save' : 'Add Student'}
        </Button>
        <Button
          size="small"
          variant="contained"
          color="inherit"
          onClick={onClose}
        >
          Cancel
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default ViewEventModal;
